import get from 'lodash/get';
import { take, takeEvery, put, select } from 'redux-saga/effects';
import { consts as communityPostsPreview } from './communityPostsPreview';
import { consts as postsList } from './postsList';
import { communityPostsListSizeSelector } from './selectors/communityPreview';

function* getPostsPreviewWorker(action) {
  // Request data according to action type
  const POSTS_PER_PAGE = 20;

  const communityId = +get(action.payload, 'communityId');
  const limit = POSTS_PER_PAGE;
  const offset = yield select(communityPostsListSizeSelector);

  // Dispatch request
  yield put({
    type: communityPostsPreview.SEND,
    payload: { communityId, limit, offset },
  });

  // Process response
  const response = yield take(communityPostsPreview.SUCCEED);

  yield put({
    type: postsList.LOAD_OLDER_POSTS_PREVIEW,
    payload: response.payload,
  });
}

export function* getPostsPreviewSaga() {
  yield takeEvery(
    [
      communityPostsPreview.GET_POSTS_PREVIEW,
      communityPostsPreview.GET_OLDER_POSTS_PREVIEW,
    ],
    getPostsPreviewWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/postsPreviewListSagas.js